import { config } from '@littlebird/sdk';
import { isOpenableUrl, isTrustedUrl } from '@littlebird/ui-utils';

import { inBrowser } from './capabilities';
import { openUntrustedUrl } from './external-links';

/**
 * A blank tab opened on a click, for a link whose address is known only after an await: a browser blocks a tab
 * opened later. Null outside a browser tab, where `openUntrustedUrl` opens the link without a gesture. The tab
 * has no opener, as a link opened with `noopener` has none
 */
export function reserveTabForLink(): Window | null {
  if (!inBrowser()) return null;
  const tab = window.open('', '_blank');
  if (tab) tab.opener = null;
  return tab;
}

/**
 * Opens the URL as `openUntrustedUrl` does, in the tab `reserveTabForLink` opened when there is one. A URL that
 * must be confirmed closes the tab and asks first, and a URL that cannot open closes it
 */
export function openUntrustedUrlIn(tab: Window | null, url: string): void {
  if (!tab) {
    openUntrustedUrl(url);
    return;
  }
  if (
    isOpenableUrl(url) &&
    (isTrustedUrl(url) || !config.chat.confirm_external_links)
  ) {
    tab.location.href = url;
    return;
  }
  tab.close();
  openUntrustedUrl(url);
}
